import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import {
  FormWrap,
} from '../styled'

// components
import Input from 'components/Input'
import Buttons from 'components/Buttons'

import Backend from 'API/backendService'
import ModalState from 'components/ModalSystem/ModalState'
import WhiteListModal from 'components/ModalSystem/Modals/Whitelist'

export default function RegisterScreen() {

  const { t, i18n } = useTranslation()

  const [email, setEmail] = useState('')
  const [nickname, setNickname] = useState('')
  const [error, setError] = useState('')

  const submitForm = async () => {

    if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      setError('email')

      return false
    }

    if (!(nickname.length >= 3 && nickname.length <= 20)) {
      setError('length')
      
      return false
    }

    setError('')
    setEmail('')
    setNickname('')
    const result = await Backend.pregister.register(email, nickname, localStorage.getItem('referal') || 'none')
    if (result.status === "success") {
      ModalState.setComponent(<WhiteListModal nickname={nickname} />)
    }
    if (result.error_code === 2) {
      setError('email')
    }
    if (result.error_code === 5) {
      setError('length')
    }


  }

  return (

    <FormWrap>

      <Input
        placeholder={t("placeholders.email")}
        value={email}
        onChange={(e: any) => setEmail(e.target.value)}
        hasError={error === 'email'}
      />
      <Input
        placeholder={t("placeholders.nickname")}
        value={nickname}
        onChange={(e: any) => setNickname(e.target.value)}
        hasError={error === 'length'}
      />
      <Buttons
        onClick={submitForm}
        variable="solid"
        height="big"
      >{t("btns.join")}</Buttons>

    </FormWrap>

  )

}